import { KeyVmDto } from "../../dto/vending/KeyVmDto";
import appType, { AppState, IAppAction } from "./app.type";

const initialState: AppState = {
  keyVMList: undefined,
  lastDataScanYearOld: undefined,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: IAppAction) => {
  switch (action.type) {
    case appType.APP.KEY_VM:
      return {
        ...state,
        keyVMList: action.payload as KeyVmDto[]
      };
    case appType.APP.SCAN_YEAR_OLD:
      return {
        ...state,
        lastDataScanYearOld: action.payload
      };
    case appType.APP.CLEAR_STATE:
      return {
        ...state,
        css: undefined,
        langJson: undefined
      };
    default:
      return state;
  }
};
